import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
  Optional,
} from '@angular/core';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import {
  ContainerItemModel,
  ContainerModel,
} from '@app/models/server/layout.model';
import { Router } from '@angular/router';
import { COMP_STATES } from '@app/constants/app-settings';
import { BehaviorSubject } from 'rxjs';
import { IntersectionStatus } from '@app/components/directives/intersection-observer/from-intersection-observer';
import { IntersectionObserverDirective } from '@app/components/directives/intersection-observer/intersection-observer.directive';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import {TapEffect} from '@app/components/directives/tap-effect.ts/tap-effect';

@Component({
  selector: 'app-b2b-overlay-card',
  templateUrl: './b2b-overlay-card.component.html',
  styleUrls: ['./b2b-overlay-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgOptimizedImage,
    AsyncPipe,
    IntersectionObserverDirective,
    TapEffect,
  ],
  animations: [],
})
export class B2bOverlayCardComponent implements OnInit {
  @Input() compData: {
    containerItem?: ContainerItemModel;
    container?: ContainerModel;
    loaded?: (value: any) => void;
  };

  commonContainer: ContainerItemModel | ContainerModel;
  pImage$: BehaviorSubject<string>;
  visibilityStatus: IntersectionStatus;
  intersectionStatus = IntersectionStatus;

  constructor(
    private router: Router,
    @Optional() @Inject('WINDOW') private window: any,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private cdref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.init();
  }

  init() {
    if (this.compData?.containerItem) {
      this.commonContainer = this.compData?.containerItem;
    } else {
      this.commonContainer = this.compData?.container;
    }

    if (this.compData?.loaded) {
      this.compData?.loaded(COMP_STATES?.LOADED);
    }

    this.pImage$ = new BehaviorSubject<string>(
      this.commonContainer?.image?.path + `?format=webp&quality=5`,
    );
  }

  onCardClick(): void {
    const navigationURL: string = this.commonContainer?.navigationURL;
    const externalUrl: string = this.commonContainer?.externalUrl;
    if (externalUrl) {
      this.b2bDeviceUtilService
        .openSite(
          externalUrl,
          this.b2bDeviceUtilService?.isDesktop() ? '_blank' : '_self',
        )
        .then((r) => {});
      return;
    }

    if (navigationURL) {
      if (this.commonContainer?.target === '_blank') {
        this.window?.open(this.window?.origin + navigationURL, '_blank');
      } else {
        this.router.navigateByUrl(navigationURL).then();
      }
    }
  }

  onVisibilityChanged(status: IntersectionStatus) {
    this.visibilityStatus = status;

    if (
      this.visibilityStatus === this.intersectionStatus?.Visible &&
      !this.b2bDeviceUtilService?.isServer()
    ) {
      let timeout = 500;
      if (this.commonContainer?.delay > 0) {
        timeout = this.commonContainer?.delay;
      }
      setTimeout(() => {
        // ngSrc="{{ slide?.image?.path }}?height={{ slide?.image?.height }}&width={{ slide?.image?.width }}&format=webp&quality=100"
        /*this.pImage$ = new BehaviorSubject<string>(
          this.commonContainer?.image?.path +
            `?format=webp&quality=90&height=${this.commonContainer?.image?.height}&width=${this.commonContainer?.image?.width}`,
        );*/

        this.pImage$ = new BehaviorSubject<string>(
          this.commonContainer?.image?.path +
            `?format=webp&quality=100&height=${this.commonContainer?.image?.minHeight}`,
        );
        /*this.loadAsyncImage();*/
        this.cdref.markForCheck();
      }, timeout);
    }
  }
}
